import { t } from 'i18next';
import * as yup from 'yup';

export default class AdminRequestCostBearerUpdate {
    constructor({
        id = "",
        name = "",
        showLabel = "",
        value = "",
        message = "",
        deleted = false,
        includedInAGI = false,
    } = {}) {
        this.id = id;
        this.name = name;
        this.showLabel = showLabel;
        this.value = value;
        this.message = message;
        this.deleted = deleted;
        this.includedInAGI = includedInAGI;
    }

    static getAttributes(filter = null, validationSchema = null) {
        const fieldRequired = t('validationMessage.fieldRequired');

        const attributes = {
            id: {
                'label': 'ID',
                'sortable': true,
                'sortField': 'id',
                'value': (item) => item.id || "",
                'required': false,
                'type': 'hidden',
            },
            name: {
                'label': t('costBearer.name'),
                'sortable': true,
                'sortField': 'name',
                'value': (item) => item.name || "",
                'required': true,
                'type': 'text',
                'placeholder': 'costbearer.namePlaceholder',
                'validation': yup.string()
                    .required('validationMessage.fieldRequired'),
            },
            showLabel: {
                'label': t('costBearer.showLabel'),
                'sortable': true,
                'sortField': 'showLabel',
                'value': (item) => item.showLabel || "",
                'required': false,
                'type': 'text',
                'placeholder': 'costbearer.showLabelPlaceholder',
                'validation': yup.string()
                    .max(255, 'validationMessage.showLabelMaxLength'),
            },
            value: {
                'label': t('costBearer.value'),
                'sortable': true,
                'sortField': 'value',
                'value': (item) => item.value || "",
                'required': true,
                'type': 'text',
                'placeholder': 'costbearer.valuePlaceholder',
                'validation': yup
                    .string()
                    .required(fieldRequired)
                    .matches(/^[0-9]+$/, t('validationMessage.valueNumeric'))
                    .max(6, t('validationMessage.max6digits'))
                    .test('maxValue', t('validationMessage.max999999'), (val) => {
                        return !val || parseInt(val, 10) <= 999999;
                    }),
            },
            message: {
                'label': t('costBearer.message'),
                'sortable': true,
                'sortField': 'message',
                'value': (item) => item.message || "",
                'required': false,
                'type': 'textarea',
            },
            deleted: {
                'label': t('costBearer.deleted'),
                'sortable': true,
                'sortField': 'deleted',
                'value': (item) => item.deleted ? 'Yes' : 'No',
                'required': false,
                'type': 'boolean',
            },
            includedInAGI: {
                'label': t('costBearer.includedInAGI'),
                'sortable': true,
                'sortField': 'includedInAGI',
                'value': (item) => item.includedInAGI ? 'Yes' : 'No',
                'required': false,
                'type': 'boolean',
            },
        };

        if (validationSchema === true) {
            const schema = yup.object().shape({
                id: attributes.id.validation || yup.string(),
                name: attributes.name.validation,
                showLabel: attributes.showLabel.validation || yup.string(),
                value: attributes.value.validation,
                message: attributes.message.validation || yup.string(),
            });
            return schema;
        }

        return attributes;
    }
}